//import React from 'react';
const PAGE = [
  {
    "content": `User Name`
  },
  {
    "content": `Treatment Plan ID`
  },
  {
    "content": `Created`
  },
  {
    "content": "View"
  },
  {
    "content": "No Items Found"
  }
];




  
export default PAGE;